export const SSOAttemptKey = 'wippy:sso:attempted'
export const LoginRedirectKey = 'wippy:login:redirected'

export interface GuardContext {
  isAuthenticated: boolean
  requiresAuth: boolean
  fullPath: string
  getFlag: (key: string) => boolean
  setFlag: (key: string) => void
  clearFlag: (key: string) => void
}

export type GuardAction = { kind: 'allow' } | { kind: 'navigate'; url: string }

export function resolveGuardAction(ctx: GuardContext): GuardAction {
  if (ctx.isAuthenticated) {
    ctx.clearFlag(SSOAttemptKey)
    ctx.clearFlag(LoginRedirectKey)
    return { kind: 'allow' }
  }

  if (!ctx.getFlag(SSOAttemptKey)) {
    ctx.setFlag(SSOAttemptKey)
    return {
      kind: 'navigate',
      url: `/auth/login?silent=1&redirect_to=${encodeURIComponent(ctx.fullPath)}`,
    }
  }

  if (!ctx.requiresAuth) return { kind: 'allow' }

  if (ctx.getFlag(LoginRedirectKey)) return { kind: 'navigate', url: '/' }

  ctx.setFlag(LoginRedirectKey)
  return {
    kind: 'navigate',
    url: `/auth/login?redirect_to=${encodeURIComponent(ctx.fullPath)}`,
  }
}
